import { darken, lighten } from 'polished';
import styled from 'styled-components';

import { FocusButton } from '@main/pc-core-components';
import { sp } from '@main/theme';

/**
 * The wrapper for current user status
 */
export const StatusWrapper = styled.section`
  padding: 12px 20px;
`;

/**
 * The wrapper for user session details
 */
export const UserWrapper = styled.section`
  margin-top: ${sp(0.7)};

  h1 {
    margin: 0;
    font-size: ${sp(2.2)};
    font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
    font-weight: 600;
    color: ${({ theme }) => theme.colors.secondary};
  }

  p {
    margin: 0;
    font-size: ${sp(1.5)};
    font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
    font-weight: 600;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.transcendNavy2};
  }
`;

/**
 * The controls wrapper for session options in the popover
 */
export const ControlsWrapper = styled.ul`
  margin: ${sp(0.5)} 0 0 0;
  border-top: 1px solid ${({ theme }) => theme.colors.transcendNavy4};
  padding: ${sp(0.5)} 0;
  list-style: none;
`;

/**
 * The Popover selections Wrapper
 */
export const SelectionWrapper = styled(FocusButton)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  outline: 0;
  text-align: left;
  font-size: ${sp(1.8)};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary};
  border-radius: ${sp(0.5)};
  padding: 6px 20px;
  &:hover {
    opacity: 0.75;
  }
  &:focus {
    box-shadow: none;
    background-color: ${({ theme }) => lighten(0.3, theme.colors.primary)};
  }
`;

export const AvatarIconWrapper = styled.div`
  span {
    background-color: ${({ theme }) => theme.colors.white};

    &:hover {
      background-color: ${({ theme }) => darken(0.03, theme.colors.white)};
    }
  }

  svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

/**
 * The AvatarPopover wrapper
 */
export const AvatarPopoverWrapper = styled.section`
  display: flex;
  flex-direction: column;
`;
